/**
 * Authoritative Canonical Watchlist SSOT for Market Hub (TSO 2.0).
 * Governance: GATE-WATCHLIST-SSOT / PROPOSAL-MARKET_HUB-ZERO-MOCK-WATCHLIST-AND-TSO2-STREAMLINE-001
 *
 * Strictly synchronized with backend:
 * - docker-compose.yml (INGEST_SPOT_SYMBOLS, INGEST_PERP_SYMBOLS)
 * - app/collector_daemon.py
 * - app/services/quant_fact_tag_dictionary_v1.py
 */

export const CANONICAL_SPOT_SYMBOLS = [
  'BTCUSDT',
  'ETHUSDT',
  'SOLUSDT',
  'BNBUSDT',
  'OKBUSDT',
  'BGBUSDT',
  'HYPEUSDT',
] as const;

export type CanonicalSpotSymbol = typeof CANONICAL_SPOT_SYMBOLS[number];

export const CANONICAL_PERP_SYMBOLS = [
  'BTCUSDT',
  'ETHUSDT',
  'SOLUSDT',
  'BNBUSDT',
  'HYPEUSDT',
] as const;

export type CanonicalPerpSymbol = typeof CANONICAL_PERP_SYMBOLS[number];

export const CANONICAL_TIMEFRAMES = [
  '1m',
  '5m',
  '15m',
  '30m',
  '1h',
  '4h',
  '1d',
] as const;

export type CanonicalTimeframe = typeof CANONICAL_TIMEFRAMES[number];

export interface VenueMetadata {
  venue: string;
  role: string;
  detailedRole: string;
  icon: string;
  badgeClass: string;
}

export const VENUE_METADATA: Record<CanonicalSpotSymbol, VenueMetadata> = {
  BTCUSDT: { venue: 'BINANCE', role: '主流锚点', detailedRole: '全市场主流基准锚点', icon: '⚡', badgeClass: 'venue-binance' },
  ETHUSDT: { venue: 'BINANCE', role: '智能合约龙头', detailedRole: '智能合约与 Layer 1 龙头', icon: 'Ξ', badgeClass: 'venue-binance' },
  SOLUSDT: { venue: 'BINANCE', role: '高吞吐公链', detailedRole: '高吞吐量高性能公链', icon: '◎', badgeClass: 'venue-binance' },
  BNBUSDT: { venue: 'BINANCE', role: '头部平台币', detailedRole: 'CeFi 头部平台币龙头', icon: '🔶', badgeClass: 'venue-binance' },
  OKBUSDT: { venue: 'OKX', role: '头部平台币', detailedRole: 'CeFi 头部平台币 / DeFi 生态', icon: '🔵', badgeClass: 'venue-okx' },
  BGBUSDT: { venue: 'BITGET', role: '头部平台币', detailedRole: 'CeFi 平台币成长核心', icon: '🔷', badgeClass: 'venue-bitget' },
  HYPEUSDT: { venue: 'HYPERLIQUID', role: 'DEX 旗舰', detailedRole: '去中心化永续合约 DEX 旗舰', icon: '🟣', badgeClass: 'venue-hyperliquid' },
};

/**
 * Strips USDT suffix for short ticker representation (e.g., BTC, ETH, HYPE)
 */
export function toShortSymbol(symbol: string): string {
  return symbol.replace(/USDT$/i, '');
}
